import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const NavStyles = styled.nav`
  display: grid;
  grid-template-columns: repeat(4, auto);
  justify-content: right;
  align-content: center;

  @media (max-width: 650px) {
    justify-content: center;
  }

  margin: 0.5rem;
  padding: 2rem;

  a + a {
    margin-left: 25px;
  }
`;

export default function Nav({ pageContext }) {
  return (
    <NavStyles aria-label="header navigation">
      <Link to="/">Home</Link>
      <Link
        to="/about"
        className={pageContext.collection === 'about' ? 'current-parent' : null}
      >
        About
      </Link>
      <Link
        to="/portfolio"
        className={
          pageContext.collection === 'portfolio' ? 'current-parent' : null
        }
      >
        Portfolio
      </Link>
      <Link
        to="/uses"
        className={pageContext.collection === 'uses' ? 'current-parent' : null}
      >
        Uses
      </Link>
    </NavStyles>
  );
}
